<template>
  <div :class="style.wrapper">
    <h3 :class="style.basicTitle">当日消化金額</h3>
    <div :class="variableClass">
      <span v-if="todayBuying.state.active">{{ todayBuying.state.value }}</span>
      <span v-if="todayBuying.bigNumber.active" :class="style.bigNumber">{{
        todayBuying.bigNumber.value
      }}</span>
      <span v-if="todayBuying.unit.active" :class="style.unit">円</span>
    </div>
  </div>
</template>

<script>
import { cx } from 'emotion'
import { baseStyle } from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/reminderStyles'
import { budgetFormatWithoutUnit } from '@/middlewares/numberFormat'
import { getters } from '@/vuex/modules/progressReport/constants'
import isEqualDate from 'date-fns/is_equal'
import formatDate from 'date-fns/format'

export default {
  name: 'TodayBuying',
  props: {
    data: Object,
  },
  computed: {
    todayBuying() {
      const data = this.data
      const today = this.$store.getters[getters.today]
      const chartData = this.$store.getters[getters.chartData]
      if (!data || !today || !chartData.length) {
        return {
          state: {
            value: '',
            active: false,
          },
          bigNumber: {
            value: '達成',
            active: true,
          },
          unit: {
            active: false,
          },
          bar: {
            active: true,
          },
        }
      }

      const { dailyBuyingCurrencyPlan } = data

      if (dailyBuyingCurrencyPlan <= 0) {
        return {
          state: {
            value: '',
            active: false,
          },
          bigNumber: {
            value: '達成',
            active: true,
          },
          unit: {
            active: false,
          },
          bar: {
            active: true,
          },
        }
      }

      const todayItem = chartData.find(eachData => {
        const { reportDate } = eachData
        return isEqualDate(formatDate(reportDate), formatDate(today))
      })

      // vuex の chartData の更新が間に合わずに、
      // 一つ前のチャートの値を参照してしまう場合があるため
      if (!todayItem) {
        return {
          state: {
            value: '',
            active: false,
          },
          bigNumber: {
            value: '',
            active: true,
          },
          unit: {
            active: false,
          },
          bar: {
            active: true,
          },
        }
      }

      const { revenueBuyingCurrency } = todayItem

      return {
        state: {
          value: '',
          active: false,
        },
        bigNumber: {
          value: `${budgetFormatWithoutUnit(
            revenueBuyingCurrency || 0,
          )} / ${budgetFormatWithoutUnit(dailyBuyingCurrencyPlan)}`,
          active: true,
        },
        unit: {
          active: true,
        },
        bar: {
          active: true,
        },
      }
    },
    variableClass() {
      return cx(baseStyle.variable)
    },
    style() {
      return baseStyle
    },
  },
  filters: {
    budgetFormatWithoutUnit,
  },
}
</script>

<style></style>
